import { deserializationPolicy, exponentialRetryPolicy, redirectPolicy, systemErrorRetryPolicy } from '@azure/ms-rest-js';
import { Api } from '@ori/global-api-client';
import { useConfigurationContext } from '../../contexts/ConfigurationContext';
import { tenantPolicy, authorizationPolicy } from './policies';

var ClientProvider = function ClientProvider() {
  var configuration = useConfigurationContext();
  var auth = authorizationPolicy();
  var tenant = tenantPolicy(configuration.tenant);
  return new Api({
    baseUri: configuration.globalApiUrl,
    // IMPORTANT - this overrides ServiceClient.createDefaultRequestPolicyFactories
    // (check if you need retries etc...)
    requestPolicyFactories: [auth, tenant, // defaultPolicies:
    deserializationPolicy(), redirectPolicy(), exponentialRetryPolicy(), systemErrorRetryPolicy()]
  });
};

export var Client = ClientProvider;